var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('create-company-screen',{attrs:{"email":_vm.email,"code":_vm.code,"username":_vm.username,"tenant":_vm.tenant}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }